import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import { FaEdit, FaTrash } from "react-icons/fa";

import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import VuiTooltip from "components/VuiTooltip";
import VuiButton from "components/VuiButton";
import VuiSwitch from "components/VuiSwitch";

const IntegrationCard = ({ integration, onEdit, onDelete, onToggle }) => {
  const isActive = integration.status === "enabled";

  return (
    <Card
      sx={{
        height: "100%",
        padding: { xs: 1, lg: 2 },
        background: "linear-gradient(135deg, rgba(255,255,255,0.10), rgba(255,255,255,0.05))",
        backdropFilter: "blur(20px)",
        WebkitBackdropFilter: "blur(20px)",
        border: "1px solid rgba(255, 255, 255, 0.2)",
        boxShadow: "0 8px 32px rgba(0, 0, 0, 0.25)",
      }}
    >
      <VuiBox
        display="flex"
        flexDirection="column"
        alignItems="center"
        height="100%"
        sx={{
          py: { xs: 1, lg: 3 },
          px: { xs: 0, lg: 1 },
        }}
      >
        {/* Logo */}
        <VuiBox
          mb={2}
          width="72px"
          height="72px"
          display="flex"
          alignItems="center"
          justifyContent="center"
          borderRadius="12px"
          sx={{ background: "rgba(255,255,255,0.06)" }}
        >
          <img
            src={integration.logoUrl}
            alt={integration.displayName}
            style={{ maxWidth: "48px", maxHeight: "48px" }}
          />
        </VuiBox>

        {/* Name */}
        <VuiTypography variant="h4" fontWeight="regular" textAlign="center">
          {integration.displayName}
        </VuiTypography>

        {/* Description */}
        <VuiTypography variant="caption" opacity={0.7} mb={0.5} mt={1}>
          {integration.description}
        </VuiTypography>

        <Divider sx={{ width: "100%", my: { xs: 0.8, lg: 2 } }} />

        {/* Actions */}
        <VuiBox
          mt="auto"
          width="100%"
          display="flex"
          flexDirection={{
            xs: "column",
            sm: "column",
            lg: "row",
          }}
          justifyContent={{
            xs: "center",
            sm: "center",
            lg: "space-between",
          }}
          alignItems="center"
          gap={2}
        >
          {/* Left: Status */}
          <VuiBox
            display="flex"
            alignItems="center"
            justifyContent={{ xs: "center", sm: "flex-start" }}
            gap={1}
          >
            <VuiSwitch color="success" checked={isActive} onChange={() => onToggle(integration)} />

            <VuiTypography variant="caption" sx={{ opacity: 0.75 }}>
              {isActive ? "Active" : "Inactive"}
            </VuiTypography>
          </VuiBox>

          {/* Right: Action buttons */}
          <VuiBox display="flex" gap={1}>
            <VuiTooltip title="Edit Integration">
              <VuiButton
                size="small"
                variant="outlined"
                color="primary"
                sx={{ px: 1.25, py: 0.5 }}
                onClick={() => onEdit(integration)}
              >
                <FaEdit size={11} style={{ marginRight: 5 }} />
                Edit
              </VuiButton>
            </VuiTooltip>

            <VuiTooltip title="Delete Integration">
              <VuiButton
                size="small"
                variant="outlined"
                color="error"
                sx={{ px: 1.25, py: 0.5 }}
                onClick={() => onDelete(integration._id)}
              >
                <FaTrash size={11} style={{ marginRight: 5 }} />
                Delete
              </VuiButton>
            </VuiTooltip>
          </VuiBox>
        </VuiBox>
      </VuiBox>
    </Card>
  );
};

export default IntegrationCard;
